import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils'
import { resetQueries } from '@/utils/api'

import { GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY } from './get-market-shop-inventory'

type BulkChangeCategoryMarketShopInventoryRequest = {
  ids: number[]
  categoryId?: number
  buildingId: number
}

type BulkActionResponse = {
  affected: number
  failed: number[]
}

const bulkChangeCategoryMarketShopInventory = async (
  data: BulkChangeCategoryMarketShopInventoryRequest,
): Promise<BulkActionResponse> => {
  const response = await authAPI.post<BulkActionResponse>('/market-shop/products/bulk', {
    action: 'changeCategory',
    ...data,
  })
  return response.data
}

export const useBulkChangeCategoryMarketShopInventory = () => {
  return useMutation({
    mutationFn: bulkChangeCategoryMarketShopInventory,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async () => {
      await resetQueries([GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY])
      toastFactory.success('Category changed successfully')
    },
  })
}
